import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { serviceConstants } from "src/app/constants/service.constants";

@Injectable({
  providedIn: 'root'
})
export class AlertsAndNotificationsServiceService {

  constructor(private readonly http: HttpClient) { } 

  getHeaders(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true
    };
    return httpOptions;
  }
  
  getanplaceholders(ModuleId:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/GetANPlaceHolders/' + ModuleId, this.getHeaders());
  }

  getanevents(ModuleId:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/GetANNotificationAndAlertEvents/' + ModuleId, this.getHeaders());
  }

  getanoutsmtpemails(ModuleId:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/GetANOutgoingSMTPEmailServers/' + ModuleId, this.getHeaders());
  }

  SaveOutgoingSMTP(ModuleId:string, emailServerId:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/SaveOutgoingSMTPEmail/' + ModuleId + '/' + emailServerId, this.getHeaders());
  }

  SaveAlertsAndNotifications(model:AlertsAndNotifications):Observable<any>{
    // return this.http.post(
    //   serviceConstants.apiURL + "api/AlertsAndNotifications/SaveAlertsAndNotifications",
    //   model,
    //   { responseType: "json", withCredentials: true }
    // ).pipe(debounceTime(500));
    return this.http.post(serviceConstants.apiURL + 'api/AlertsAndNotifications/SaveAlertsAndNotifications',model, this.getHeaders());
  }

  getansummarydata(ModuleId:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/GetAlertsAndNotificationsSummary/' + ModuleId, this.getHeaders());
  }

  getanbyid(ModuleId:string,Id:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/AlertsAndNotifications/GetAlertsAndNotificationsById/' + ModuleId + '/' + Id, this.getHeaders());
  }

  getusernotifications(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Notifications/GetUserNotifications', this.getHeaders());
  }

  updateusernotifications(orgusernotificationid:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Notifications/UpdateNotification/'+ orgusernotificationid, this.getHeaders());
  }

}

export interface AlertsAndNotifications {
  AlertNotificationID?: string;
  ModuleId:string;
  Name?: string;
  RecordState?: number;
  TargetUser:string;
  ANType: string;
  NotificationEventID: string;
  AlertEventID: string;
  EventDays: number;
  IsEmailAlert: boolean;
  ToAddress: string;
  ToPlaceHolders: string;
  CcAddress: string;
  CcPlaceHolders: string;
  Subject: string;
  EmailBodyID: string;
  EmailBody: string;
  IsSystemNotification: boolean;
  NotificationToPlaceHolder: string;
  NotificationText: string;
  IsEmailEnabled?: boolean;
  IsNotifEnabled?: boolean;
  OperationType:string;
}
